import React from 'react';
import styled from 'styled-components';
import { H4, Bold, Light } from '../../../components/Typography/Typography';
import { Calendar, Folder, Learn, Teaching, SVG } from '../../../icons/Icons';
import { media } from '../../../components/style-utils';

export const SectionIncludes = function() {
  return (
    <Container>
      <H4>This powerful program&nbsp;includes</H4>
      <GridLayout>
        <GridBlock>
          <GridItem>
            <Icon>
              <Folder checked={true} />
            </Icon>
            <Title>Course Curriculum</Title>
            <Description>
              Learn the 6-part process for using social media to accomplish your church’s biggest goals
            </Description>
          </GridItem>
          <GridItem>
            <Icon>
              <Learn checked={true} />
            </Icon>
            <Title>Hands-On Mentorship</Title>
            <Description>
              Accelerate your growth with unlimited 1-on-1 email access, attend weekly live training calls, and connect
              with other churches on the same path
            </Description>
          </GridItem>
        </GridBlock>
        <GridBlock>
          <GridItem>
            <Icon>
              <Calendar checked={true} />
            </Icon>
            <Title>The 1-Year Social Media Calendar</Title>
            <Description>
              Gain instant access to 365 planned out social media posts that will cover you for the full year (plus, all
              the source files & templates)
            </Description>
          </GridItem>
          <GridItem>
            <Icon>
              <Teaching checked={true} />
            </Icon>
            <Title>Execution Plans</Title>
            <Description>
              Look over Brady’s shoulder as he builds, optimizes, and executes high-level social media strategies
            </Description>
          </GridItem>
        </GridBlock>
      </GridLayout>
    </Container>
  );
};

const Container = styled.section`
  position: relative;
  width: 100vw;
  background-color: white;

  text-align: center;

  padding: 4rem 1rem 7rem;
`;

const Icon = styled.div`
  text-align: left;

  height: 6.2rem;
  margin-top: 5rem;
  margin-bottom: 2rem;

  ${SVG} {
    height: 100%;
  }
`;

const GridLayout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${media.desktopAndUp`
    flex-direction: row;
  `}
`;

const GridBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${media.tabletPortraitAndUp`
    flex-direction: row;
  `}
`;

const GridItem = styled.div`
  max-width: 24rem;
  margin-left: auto;
  margin-right: auto;

  ${media.tabletPortraitAndUp`
    margin-left: 3rem;
    margin-right: 3rem;
  `}
`;

const Title = styled(Bold)`
  display: block;
  text-align: left;
  margin-bottom: 1rem;

  font-size: 2.4rem;
  line-height: calc(2.4 / 2.4 * 1em);
  letter-spacing: calc(-0.5 / 2.4 * 0.1em);
`;

const Description = styled(Light)`
  display: block;
  text-align: left;

  font-size: 1.6rem;
  line-height: calc(2 / 1.6 * 1em);
  letter-spacing: calc(-0.5 / 1.6 * 0.1em);
`;



// WEBPACK FOOTER //
// ./src/routes/Home/components/SectionIncludes.js